export default __webpack_public_path__ + "static/media/finlist-highlighted-m.e62619b2.png";